import { stringify } from 'query-string';
import toSnakeCase from 'to-snake-case';
import { apiCreate, apiDelete } from './ApiBaseActions';
export const API_CREATE_PROFFIT_SEARCH_SLIDE_SELECT = 'API_CREATE_PROFFIT_SEARCH_SLIDE_SELECT';
export const API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT = 'API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT';
export const API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT_ALL = 'API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT_ALL';
/**
 * スライドを選択状態に更新
 * @param fileType
 * @param params
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateSlideSelect = (fileType, params, meta) => apiCreate(API_CREATE_PROFFIT_SEARCH_SLIDE_SELECT, `/proffit_search/slide/select/${fileType}`, params, meta);
/**
 * スライドの選択状態を解除
 * @param fileType
 * @param requestKey
 * @param idList
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiDeleteSlideSelect = (fileType, requestKey, idList, meta = {}) => apiDelete(API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT, `/proffit_search/slide/select/${fileType}?${stringify({
    [toSnakeCase(requestKey)]: idList.join(','),
})}`, meta);
/**
 * スライドの選択状態を全て解除
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiDeleteSlideSelectAll = (meta) => apiDelete(API_DELETE_PROFFIT_SEARCH_SLIDE_SELECT_ALL, '/proffit_search/slide/select', meta);
